module.exports = __webpack_public_path__ + "static/KerryCar5-9c6680cd96879d2e6a62ccbfe22be836.jpg";